import { render, staticRenderFns } from "./ed-list-item.vue?vue&type=template&id=36129e0d&scoped=true&"
import script from "./ed-list-item.ts?vue&type=script&lang=js&"
export * from "./ed-list-item.ts?vue&type=script&lang=js&"
import style0 from "./ed-list-item.scss?vue&type=style&index=0&id=36129e0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36129e0d",
  null
  
)

export default component.exports